import { useState, useEffect } from 'react'
import * as contactoService from '../servicios/contactoService'
import Banderas from './Banderas'
import InfoContacto from './InfoContacto'
import MensajeContacto from './MensajeContacto'

const Contacto = () => {
  const [contacto, setContacto] = useState([])
  // const [epais, setEpais] = useState(null)

  const traerDatos = async (pais) => {
    // setEpais(pais)
    const { data: cons } = await contactoService.buscarTodos(pais)
    setContacto(cons)
  }

  useEffect(() => {
    const fetchContacto = async () => {
      const { data: con } = await contactoService.buscarTodos('AR')
      setContacto(con)
    }

    fetchContacto()
  }, [])

  return (
    <div className="section section-border">
      <h4 className="titulo-seccion">Contacto</h4>
      <div className="border">
        <div className="row item">
          <div className="col">
            <Banderas traerDatos={traerDatos} />
            <div className="row inicial-item">
              <MensajeContacto />
              <InfoContacto contacto={contacto} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contacto
